import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import SupplierFinancing from "./SupplierFinancing";
import BorrowerFinancing from "./BorrowerFinancing";
// import BorrowerCreditDetails from "./BorrowerCreditDetails";

const FinancingTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ borderBottom: "1px solid #E0E0E0", mb: 2 }}
      >
        <Tab label="Supplier Financing" />
        <Tab label="Borrower Financing" />
      </Tabs>

      {activeTab === 0 && <SupplierFinancing />}

      {activeTab === 1 && (
        <Box p={2}>
          <BorrowerFinancing />
        </Box>
      )}
    </Box>
  );
};

export default FinancingTabs;
